import { CarbUnit } from '../types';

export const convertCarbs = (grams: number, unit: CarbUnit): number => {
  switch (unit) {
    case 'g':
    case 'gKH':
      return grams;
    case 'KE':
      return grams / 10;
    case 'BE':
      return grams / 12;
    case 'BU':
      return grams / 12; // BU is same as BE
    default:
      return grams;
  }
};

export const formatCarbs = (grams: number, unit: CarbUnit, locale: 'en' | 'de' = 'en'): string => {
  const converted = convertCarbs(grams, unit);
  let formatted: string;
  
  if (locale === 'de') {
    // German locale: use comma as decimal separator
    formatted = converted.toFixed(1).replace('.', ',');
  } else {
    // English locale: use dot as decimal separator
    formatted = converted.toFixed(1);
  }
  
  return `${formatted} ${unit}`;
};

export const calculateCarbsForPortion = (
  carbsPer100g: number,
  portionGrams: number
): number => {
  return (carbsPer100g * portionGrams) / 100;
};